import {
  AspectRatio,
  Badge,
  Box,
  Button,
  Card,
  Heading,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import { MessageCircle } from "lucide-react";
import Footer from "../../../components/Footer";
import {
  MAIN_TUTORIALS,
  PROCESS_TUTORIALS,
  WHATSAPP_SUPPORT_URL,
} from "../../../config/tutorials";
import CommonLayout from "../CommonLayout";

const cardStyles = {
  bg: "white",
  rounded: "lg",
  border: "none",
  boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px",
} as const;

const TutorialsContainer = () => {
  const content = (
    <VStack gap={6} align="stretch" maxW="5xl" mx="auto" w="full">
      {MAIN_TUTORIALS.map((tutorial, index) => (
        <Card.Root key={tutorial.id} {...cardStyles} p={{ base: 5, md: 8 }}>
          <Card.Body p={0}>
            <Badge colorPalette="purple" rounded="full" px={2} mb={2}>
              Video {index + 1} de {MAIN_TUTORIALS.length}
            </Badge>
            <Heading size="md" fontWeight="semibold">
              {tutorial.title}
            </Heading>
            <Text
              mt={2}
              mb={4}
              fontSize="sm"
              color="gray.600"
              lineHeight="tall"
            >
              {tutorial.description}
            </Text>
            <AspectRatio ratio={16 / 9} rounded="md" overflow="hidden">
              <iframe
                src={tutorial.embedUrl}
                title={tutorial.title}
                allowFullScreen
                loading="lazy"
              />
            </AspectRatio>
          </Card.Body>
        </Card.Root>
      ))}

      <Box>
        <Heading size="md" fontWeight="semibold">
          Videos específicos por proceso
        </Heading>
        <Text mt={1} mb={4} fontSize="sm" color="gray.600">
          Procesos puntuales explicados en detalle. Consúltalos cuando necesites
          ejecutar alguna de estas tareas por primera vez.
        </Text>
        <SimpleGrid columns={{ base: 1, lg: 2 }} gap={6}>
          {PROCESS_TUTORIALS.map((tutorial) => (
            <Card.Root key={tutorial.id} {...cardStyles} overflow="hidden">
              <AspectRatio ratio={16 / 9}>
                <iframe
                  src={tutorial.embedUrl}
                  title={tutorial.title}
                  frameBorder="0"
                  allowFullScreen
                  loading="lazy"
                />
              </AspectRatio>
              <Card.Body p={4}>
                <Text fontWeight="semibold">{tutorial.title}</Text>
                <Text fontSize="sm" color="gray.500" mt={1}>
                  {tutorial.description}
                </Text>
              </Card.Body>
            </Card.Root>
          ))}
        </SimpleGrid>
      </Box>

      <Card.Root {...cardStyles} p={{ base: 5, md: 8 }}>
        <Card.Body p={0} textAlign="center">
          <Heading size="md" fontWeight="semibold">
            ¿Tienes alguna duda?
          </Heading>
          <Text mt={2} mb={4} fontSize="sm" color="gray.600">
            Nuestro equipo está disponible para acompañarte en lo que necesites.
          </Text>
          <Button asChild colorPalette="palomma">
            <a href={WHATSAPP_SUPPORT_URL} target="_blank" rel="noreferrer">
              <MessageCircle size={16} />
              Escríbenos
            </a>
          </Button>
        </Card.Body>
      </Card.Root>
    </VStack>
  );

  return CommonLayout({
    title: "Tutoriales",
    subtitle:
      "Sigue los videos en orden — en menos de 30 minutos dominarás tu portal",
    table: content,
    footer: <Footer />,
  });
};

export default TutorialsContainer;
